import { render, staticRenderFns } from "./RenovacionAutomatica.vue?vue&type=template&id=1db748f0"
import script from "./RenovacionAutomatica.vue?vue&type=script&lang=js"
export * from "./RenovacionAutomatica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports